<mat-form-field class="hide-gt-sm" floatLabel="always">
  <select matNativeControl [value]="selectedLocationId" (change)="onLocationSelect($event.target.value)">
    <option value="account" [selected]="selectedLocationId === null">Your Account</option>
    @for (loc of locations; track loc) {
      <option [value]="loc.id" [selected]="selectedLocationId === loc.id">
        {{ loc.name }}
        @if (!loc.unique) {
          &nbsp;({{ loc.customer }})
        }
      </option>
    }
  </select>
</mat-form-field>
